/**
 * Formats a number so thousands are separated by commas
 * @param num a number
 */
export function formatNumberWithCommas(num: number): string {
    return num.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
}
